import { render, staticRenderFns } from "./Remarks.vue?vue&type=template&id=3cc10ef4&scoped=true"
import script from "./Remarks.vue?vue&type=script&lang=ts"
export * from "./Remarks.vue?vue&type=script&lang=ts"
import style0 from "./Remarks.vue?vue&type=style&index=0&id=3cc10ef4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc10ef4",
  null
  
)

export default component.exports